import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader';

import PriceList from './PriceList';
import { updatePricingData, fetchPricingData } from './actions';
import { getSelectedLanguage, getData, isLoaded, getError } from './selectors';

class Pricing extends Component {
  handleSave = items => {
    const { lang, data } = this.props;
    console.log('saving', data);

    this.props.updatePricingData(items, data.id, lang);
  };

  render() {
    const { isLoaded, lang, data } = this.props;

    if (lang === '') {
      return <div />;
    }

    return (
      <div className="pricing">
        <Loader loaded={isLoaded}>
          <PriceList data={data} onSave={this.handleSave} />
        </Loader>
      </div>
    );
  }
}

const mapStatetoProps = state => {
  return {
    isLoaded: isLoaded(state),
    lang: getSelectedLanguage(state),
    data: getData(state),
    error: getError(state)
  };
};

const mapDispatchToProps = {
  fetchPricingData,
  updatePricingData
};

export default compose(
  withRouter,
  connect(
    mapStatetoProps,
    mapDispatchToProps
  )
)(Pricing);



// WEBPACK FOOTER //
// ./src/modules/Pricing/index.js